import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import MarkerText from './MarkerText'
import SpellIcon from './SpellIcon'
import { CUSTOM_ABILITY_SPELL_ID } from '../utils/encounterAssignmentRows'
import { AssignmentDependencyOption } from './assignmentDependencies'

type Props = {
  option?: AssignmentDependencyOption
  className?: string
}

const AssignmentDependencyLine = ({ option, className }: Props) => {
  const { t } = useTranslation()
  if (!option) return null
  return (
    <span
      className={cn(
        'flex min-w-0 items-center gap-1 text-xs leading-tight',
        className,
      )}
    >
      <span className='shrink-0 text-muted-foreground'>
        {t('dashboard.team.plans.assignments.depends-on')}
      </span>
      <SpellIcon
        spellId={option.isCustom ? CUSTOM_ABILITY_SPELL_ID : option.spellId}
        className='w-3.5 h-3.5 rounded-sm shrink-0'
      />
      <span className='max-w-32 truncate' style={{ color: option.color }}>
        <MarkerText text={option.name} />
      </span>
      {option.groupLabel ? (
        <span className='min-w-0 truncate text-muted-foreground'>
          <MarkerText text={option.groupLabel} />
        </span>
      ) : null}
    </span>
  )
}

export default AssignmentDependencyLine
